<template>
  <div class="app-buttons-container" :class="{ left, right }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppButtonsContainer',

  props: {
    left: {
      type: Boolean,
      default: false,
    },

    right: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/styles/settings.scss' as *;

.app-buttons-container {
  &.left {
    margin-right: auto;
  }

  &.right {
    margin-left: auto;
  }
}
</style>
